<template>
  <v-chip disabled outline :color="color" small>{{ text }}</v-chip>
</template>

<script>
export default {
  name: 'ResourceType',
  props: { value: String },
  computed: {
    text() {
      switch (this.value) {
        case 'oem':
          return '共通'
        case 'agency':
          return '代理店'
        case 'advertiser':
          return '広告主'
        case 'insertion_order':
          return '案件'
        default:
          return this.value
      }
    },
    color() {
      switch (this.value) {
        case 'oem':
          return 'success'
        case 'agency':
          return 'info'
        case 'advertiser':
          return 'pink'
        case 'insertion_order':
          return 'primary'
        default:
          return 'black'
      }
    },
  },
}
</script>
